<template>
  <div class="UXtagInp">
    <v-text-field
      ref="tagInp"
      class="tag-input"
      v-model="tagInput"
      placeholder="タグ入力"
      color="6D8DFF"
      :append-icon="tagInput && tagInput.length ? 'close': 'edit'"
      @input="resize"
      @keydown.enter.exact.prevent
      @keyup.enter.exact="sendTag()"
      @click:append="tagInput && tagInput.length ? removeTaginp() : sendTag()"
      hide-details
      outline
      solo
      maxLength="100"
    ></v-text-field>
    <div ref="tagHideTxt" class="hideTagText">{{tagInput}}</div>
    <p v-for="(item, index) in tags" :key="index" class="UXtagItem">{{item}} <i class="UXicon-close" @click="deleteTag(item)"></i></p>
  </div>
</template>

<script>
export default {
  name: 'batch_ticket_tag_list',
  data () {
    return {
      tagInput: '',
      tags: []
    }
  },
  methods: {
    deleteTag (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    sendTag () {
      let inputValue = this.tagInput.replace(/ /g, '')
      if (inputValue && this.tags.indexOf(inputValue) === -1) {
        this.tags.push(inputValue)
        this.removeTaginp()
      }
    },
    removeTaginp () {
      this.tagInput = ''
      this.resize()
    },
    resize () {
      setTimeout(() => {
        this.$refs.tagInp.$el.style.width = (this.$refs.tagHideTxt.offsetWidth + 60) + 'px'
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/dialog/batch_ticket_tag_list.vue